export enum eSolarPanels {
  None = 'NONE',
  OwnedOutright = 'OWNED_OUTRIGHT',
  Financed = 'FINANCED',
  Rented = 'RENTED',
}

export const DisplaySolarPanels = {
  [eSolarPanels.None]: 'None',
  [eSolarPanels.Financed]: 'Financed',
  [eSolarPanels.OwnedOutright]: 'Owned Outright',
  [eSolarPanels.Rented]: 'Rented',
};
